import { all } from "redux-saga/effects";

// Root saga. No watchers yet on the marketing site — add sagas here as
// authenticated consulting features come online.
export default function* rootSaga() {
  yield all([]);
}
